import * as React from 'react';
import classNames from 'classnames';

import { CancelButton, ICancelButton } from './internal/CancelButton';
import { ConfirmButton, IConfirmButton } from './internal/ConfirmButton';

import * as styles from './styles.css';

interface IFormFooter {
  className?: string;
  disabled?: boolean;
  onCancel: ICancelButton['onClick'];
  onSubmit?: IConfirmButton['onClick'];
  isMobile?: boolean;
}

export const FormFooter: React.FC<IFormFooter> = ({ className, onCancel, onSubmit, disabled, isMobile }) => (
  <div className={classNames(styles['root'], { [styles['mobile']]: isMobile }, className)}>
    <div className={styles['button']}>
      <CancelButton onClick={onCancel} isMobile={isMobile} />
    </div>
    <div className={styles['button']}>
      <ConfirmButton onClick={onSubmit} disabled={disabled} isMobile={isMobile} />
    </div>
  </div>
);

FormFooter.displayName = 'FormFooter';
